module.exports = __webpack_public_path__ + "static/media/proequidad_logo.0ee01d9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/proequidad_logo.svg
// module id = 454
// module chunks = 0